import { FunctionComponent, RefObject, useEffect, useRef, useState } from "react";

// Main Component props type
type GeneralInfoSectionProps = {
  data: {
    highlights?: string | null;
    overview?: string | null;
  };
  containerRef?: RefObject<HTMLDivElement>;
};

// Main Component
export const GeneralInfoSection: FunctionComponent<GeneralInfoSectionProps> = (props) => {
  // Return HTML component
  return (
    <div className="flex flex-col gap-8 mt-8" ref={props.containerRef}>
      <div className="flex flex-col gap-4">
        <h2 className="text-xl font-bold text-slate-800">Agent Highlights</h2>

        {props.data.highlights && <ExpandableText text={props.data.highlights} />}
        {!props.data.highlights && <p>N/A</p>}
      </div>

      <div className="flex flex-col gap-4">
        <h2 className="text-xl font-bold text-slate-800">Property Overview</h2>

        {props.data.overview && <ExpandableText text={props.data.overview} />}
        {!props.data.overview && <p>N/A</p>}
      </div>
    </div>
  );
};

// Usable Component props
type ExpandableTextProps = {
  text: string;
};

// Usable Component
const ExpandableText: FunctionComponent<ExpandableTextProps> = (props) => {
  // Constants definitions
  const [showButton, setShowButton] = useState(false);
  const [showText, setShowText] = useState(false);
  const ref = useRef<HTMLParagraphElement | null>(null);

  // Use effect to set if show button or not
  useEffect(() => {
    if (ref.current && ref.current.scrollHeight > ref.current.clientHeight) {
      setShowButton(true);
    }
  }, []);

  // return HTML component
  return (
    <div className="flex flex-col gap-1">
      <p
        className={`prose prose-slate min-w-full line-clamp-[10] prose-ul:leading-4 prose-ol:leading-4 ${
          showText && "line-clamp-none"
        }`}
        dangerouslySetInnerHTML={{ __html: props.text }}
        ref={ref}
      ></p>

      {showButton && (
        <button
          onClick={() => setShowText(!showText)}
          className="w-max text-sky-600 border h-8 px-4 rounded border-slate-400"
        >
          {showText ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};
